<template>
	<div class="fc-product-customize" @click.self="cancel">
		<div tabindex="0">
			<div v-bind:class="{ 'fc-header': true, 'fc-fixed': toTopShow }">
				<div>{{ product.ProductName }} - <span>{{ product.ProductsMainOptionName }}</span></div>
				<a @click="cancel"></a>
			</div>
			<div class="fc-content">
				<div class="fc-item" v-if="enableOption" v-for="option in enabledOptions">
					<label>{{ option.ProductsOptionName }} <span v-if="option.ChooseOptionLabel != null && option.ChooseOptionLabel != ''">({{ option.ChooseOptionLabel }})</span><a v-if="option.SetToStandardLabel != ''" @click="resetOption(option)">{{ option.SetToStandardLabel }}</a></label>
					<ul>
						<li v-for="item in option.Variants" :class="{ 'fc-active': product.OptionsVariantIds.includes(item.OptionsVariantId), 'fc-non': item.PhotoKey == '' }" @click="selectOption(item.OptionsVariantId)">
							<div v-if="item.PhotoKey == ''"><i class="icon-ico-non"></i></div>
							<img v-if="item.PhotoKey != ''" :src="item.PhotoKey" />
							<span>{{ item.OptionsVariantName }}</span>
              <span class="fc-price" v-if="item.OptionsVariantPrice > 0">${{ item.OptionsVariantPrice | price }}</span>
						</li>
					</ul>
				</div>
				<div class="fc-item" v-if="canSetBoxName">
					<label>Enter a name to identify this lunchbox</label>
					<input type="text" v-model="boxName" />
				</div>
				<div class="fc-item">
					<label>Quantity</label>
					<div class="fc-quantity">
						<a @click="(product.quantity) > 1 ? (changeQuantity(product.quantity - 1)) : changeQuantity(1)" v-bind:class="{'fc-active': (product.quantity > 1)}"></a>
							<span>{{ product.quantity }}</span>
						<a @click="changeQuantity(product.quantity + 1)" class="fc-active"></a>
					</div>
				</div>
			</div>
			<div class="fc-control">
				<a v-bind:disabled="!finish" @click="addProductToCart">
					<span>Add to cart</span>
					<span>${{ totalPrice }}</span>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields'
import { mapGetters, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
export default {
  data () {
    return {
      toTopShow: false,
      boxName: ''
    }
  },
  props: [
    'productId',
    'optionId',
    'showOption'
  ],
  computed: {
    ...mapGetters('category', ['categoryList']),
    ...mapGetters('product', ['finish']),
    ...mapFields('product', {
      product: 'productDetail'
    }),
    ...mapMultiRowFields('product',
      {
        options: 'productDetail.ProductsOptions'
      }
    ),
    canSetBoxName () {
      const cats = this.categoryList.filter(a => a.CategoryId === this.product.CategoryId)
      if (cats.length < 1) {
        return false
      }
      const canSet = cats[0].FSetBoxName
      return canSet !== undefined && canSet !== null && canSet === true
    },
    enabledOptions () {
      return this.options.filter(a => a.NotAllowChange === false)
    },
    totalPrice () {
      const selOptionIds = this.product.OptionsVariantIds
      const needOptions = this.product.ProductsOptions
      if (needOptions === null || needOptions === undefined || needOptions.length < 1) {
        return Number.parseFloat(this.product.BasePrice * this.product.quantity).toFixed(2)
      }
      var price = 0.0
      for (var i = 0; i < needOptions.length; i++) {
        const vars = needOptions[i].Variants
        for (var j = 0; j < vars.length; j++) {
          if (selOptionIds.indexOf(vars[j].OptionsVariantId) > -1) {
            price += vars[j].OptionsVariantPrice
          }
        }
      }
      const subprice = this.product.BasePrice + price
      const tmpPrice = subprice * this.product.quantity
      return Number.parseFloat(tmpPrice).toFixed(2)
    },
    enableOption () {
      return this.showOption !== false
    }
  },
  methods: {
    ...mapActions('product', [
      'changeQuantity', 'selectOption', 'resetOption'
    ]),
    addProductToCart () {
      if (!this.finish) {
        return
      }
      var cartProduct = JSON.parse(JSON.stringify(this.product))
      cartProduct.OptionsVariantIds = cartProduct.OptionsVariantIds.filter(a => a > 0)
      cartProduct = {
        BoxName: this.boxName,
        Qty: cartProduct.quantity,
        IsQuickOrder: !this.enableOption,
        ...cartProduct
      }
      this.$store.dispatch('cart/addProductToCart', cartProduct)
        .then(() => {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'auto'
          document.querySelector('.fc-product-customize >div').removeEventListener('scroll', this.handleScroll)
          this.$emit('cancel')
        })
    },
    handleScroll () {
      this.scrollTop = document.querySelector('.fc-product-customize >div').scrollTop
      this.toTopShow = this.scrollTop > 50
    },
    cancel () {
      document.body.style.position = 'initial'
      document.body.style.overflow = 'auto'
      document.querySelector('.fc-product-customize >div').removeEventListener('scroll', this.handleScroll)
      this.$emit('cancel')
    }
  },
  created () {
    const data = {
      productId: this.productId,
      optionId: this.optionId
    }
    this.$store.dispatch('product/getProductDetails', data)

    document.body.style.position = 'fixed'
    document.body.style.overflow = 'hidden'
    this.$nextTick(function () {
      document.querySelector('.fc-product-customize >div').addEventListener('scroll', this.handleScroll)
    })
  },
  destoryed () {
    document.body.style.position = 'initial'
    document.body.style.overflow = 'auto'
    document.querySelector('.fc-product-customize >div').removeEventListener('scroll', this.handleScroll)
  },
  directives: {
    ClickOutside
  }
}
</script>


// WEBPACK FOOTER //
// src/components/product/Customize.vue